import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'translate'
})

export class TranslatePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    let lang = window['appGlobals'].constants.translations;

    let tmp = document.createElement("DIV");
    tmp.innerHTML = value;
    let needle = tmp.textContent || tmp.innerText || "";
    for( let f in lang){

             if(f.trim().toLowerCase() === needle.trim().toLowerCase()){
               return value.replace(needle,lang[f])
             }
    }
    return value

  }
}



